<template>
    <div class="row">
        <!-- Annual Report Card -->
        <div class="col-lg-4 col-md-6" v-if="quickdownload?.annual_report"
            data-aos="fade-up" 
            data-aos-offset="300" 
            data-aos-duration="600" 
            data-aos-delay="200"
        >
            <div class="card card--download">
                <div class="card__body">
                    <div class="card__wrapper">
                        <div class="card__title text-center">{{ quickdownload?.annual_report?.title }}</div>
                        <div class="card__img">
                            <img :src="quickdownload?.annual_report?.cover" :alt="quickdownload?.annual_report?.title">
                        </div>
                    </div>
                    <div class="card__btn">
                        <NuxtLink 
                            v-if="quickdownload?.annual_report?.pdf_url"
                            class="btn btn--download" 
                            :to="quickdownload?.annual_report?.pdf_url"
                            target="_blank"
                        >
                            <span class="btn__icon"><i class="icon-download"></i></span>
                            <span class="btn__title">{{ translate('download') }}</span>
                        </NuxtLink>
                        <NuxtLink 
                            v-if="quickdownload?.annual_report?.online_url"
                            class="btn btn--download" 
                            :to="quickdownload?.annual_report?.online_url"
                            target="_blank"
                        >
                            <span class="btn__icon"><i class="icon-view-online"></i></span>
                            <span class="btn__title">{{ translate('view.online') }}</span>
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </div>
        <!-- Financial Statement Card -->
        <div class="col-lg-4 col-md-6" v-if="quickdownload?.financial"
            data-aos="fade-up" 
            data-aos-offset="300" 
            data-aos-duration="600" 
            data-aos-delay="400"
        >
            <div class="card card--download">
                <div class="card__body">
                    <div class="card__title">{{ quickdownload?.financial.title }}</div>
                    <div class="card__list">
                        <template v-for="(item, index) in quickdownload.financial.items.slice(0, -1)" :key="index">
                            <NuxtLink class="btn btn--download" :to="item.url" target="_blank">
                            <span class="btn__icon">
                                <i class="icon-download"></i>
                            </span>
                            <span class="btn__title">{{ item.label }}</span>
                            </NuxtLink>
                        </template>
                    
                        <NuxtLink 
                            class="btn btn--download" 
                            :to="quickdownload.financial.items[quickdownload.financial.items.length - 1].url"
                            target="_blank"
                        >
                            <span class="btn__icon"><i class="icon-download-all"></i></span>
                            <span class="btn__title">{{ quickdownload.financial.items[quickdownload.financial.items.length - 1].label }}</span>
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4"
            data-aos="fade-up" 
            data-aos-offset="300" 
            data-aos-duration="600" 
            data-aos-delay="600"
        >
            <div class="row">
                <!-- MDA -->
                <div class="col-md-6 col-lg-12" v-if="quickdownload?.mda">
                    <div class="card card--download">
                        <div class="card__body">
                            <div class="card__title">{{ quickdownload?.mda?.title }}</div>
                            <div class="card__btn">
                                <NuxtLink 
                                    v-if="quickdownload?.mda?.pdf_url"
                                    class="btn btn--download" 
                                    :to="quickdownload?.mda?.pdf_url"
                                    target="_blank"
                                >
                                    <span class="btn__icon"><i class="icon-download"></i></span>
                                    <span class="btn__title">{{ translate('download') }}</span>
                                </NuxtLink>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Opportunity Day -->
                <div class="col-md-6 col-lg-12" v-if="quickdownload?.opportunity_day">
                    <div class="card card--download">
                        <div class="card__body">
                            <div class="card__title">{{ quickdownload?.opportunity_day?.title }}</div>
                            <div class="card__btn">
                                <NuxtLink 
                                    v-if="quickdownload?.opportunity_day?.pdf_url"
                                    class="btn btn--download" 
                                    :to="quickdownload?.opportunity_day?.pdf_url"
                                    target="_blank"
                                >
                                    <span class="btn__icon"><i class="icon-download"></i></span>
                                    <span class="btn__title">{{ translate('download') }}</span>
                                </NuxtLink>
                                <NuxtLink 
                                    v-if="quickdownload?.opportunity_day?.webcast_url"
                                    class="btn btn--download" 
                                    :to="quickdownload?.opportunity_day?.webcast_url"
                                    target="_blank"
                                >
                                    <span class="btn__icon"><i class="icon-play"></i></span>
                                    <span class="btn__title">{{ translate('view.webcast') }}</span>
                                </NuxtLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script setup>

const props = defineProps({
    posts: {
        type: [Object, Array],
        required: true,
    },
    translate: {
        type: Function,
        required: true
    }
})
  
const quickdownload = ref({
  annual_report: null,
  financial: null,
  mda: null,
  opportunity_day: null
})

const fetchService = async () => {
    console.log('Fetching service...');
    console.log(props.posts);
    console.log(props.posts.value);
    const items = props.posts
    // Annual Report (report_one)
    const annualReport = items.find(item => item.category === 'report_one')
    if (annualReport) {
        quickdownload.value.annual_report = {
        title: annualReport.title,
        cover: annualReport.thumbnail,
        pdf_url: annualReport.file,
        online_url: annualReport.url
        }
    }
    // Financial Statement
    const financial = items.find(item => item.category === 'financials')
    if (financial) {
        quickdownload.value.financial = {
            title: financial.title,
            items: [
                {
                label: props.translate('auditor.report'),
                url: financial.urls.AUDITOR_REPORT
                },
                {
                label: props.translate('financial'),
                url: financial.urls.FINANCIAL_STATEMENTS
                },
                {
                label: props.translate('note'),
                url: financial.urls.NOTES
                },
                {
                label: props.translate('download.all'),
                url: financial.url
                }
            ]
        }
    }
    // MDA
    const mda = items.find(item => item.category === 'mda')
    if (mda) {
        quickdownload.value.mda = {
            title: mda.title,
            pdf_url: mda.file
        }
    }
    // Opportunity Day
    const oppDaySlides = items.find(item => item.category === 'slides')
    const oppDayWebcast = items.find(item => item.category === 'webcast')
    if (oppDaySlides || oppDayWebcast) {
        quickdownload.value.opportunity_day = {
            title: oppDaySlides?.title || oppDayWebcast?.title,
            pdf_url: oppDaySlides?.file,
            webcast_url: oppDayWebcast?.file
        }
    }
    console.log('Processed data:', quickdownload.value)
}

onMounted(async () => {
    await fetchService()
})

</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
    html[lang="#{$lang}"] {
        .card {
            &.card--download{
                .card__title {
                    @include font-family('heading', $lang);
                    @include font-size("h4", $lang);
                    @include font-weight("bold", $lang);
                }
            }
        }
    }
}
.card {
    &.card--download{
        height: 100%;
        padding-bottom: 1.65rem;
        .card__body{
            border-radius: 12px;
            padding: 1.45rem 1rem;
            color: $darkgreen-1;
            background-color: $white;
            height: 100%;
            display: flex;
            flex-direction: column;
            @include media-breakpoint-down(lg) {
                padding: 1rem;
            }
        }
        .card__title{
          color: $green-2;
          margin-bottom: 1rem;
          letter-spacing: 0.4px;
        }
        .card__img{
            text-align: center;
            margin-bottom: 1rem;
            img{
                max-width: 100%;
                height: auto;
                max-height: 154px;
            }
        }
        .card__list{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .btn{
                margin-bottom: 1rem;
            }
        }
        .card__btn{
            margin-top: auto;
            display: flex;
            justify-content: space-between;
            .btn{
                &:not(:last-child){
                    margin-right: 0.65rem;
                }
            }
            @include media-breakpoint-only(lg) {
                display: block;
                margin-top: 1.75rem;
                .btn{
                    &:not(:last-child){
                        margin-bottom: 0.65rem;

                    }
                }
            }
        }
    }
}
</style>